"use client"

import Heading from "components/Heading/Heading";
import React, { FC } from "react";
// Image imports remain the same
import Business from "./images/business.jpg";
import Event from "./images/event.jpg"
import Flim from "./images/film.jpg"
import Transport from "./images/transportaton.jpg"
import Hotel from "./images/hotel.jpg"
import Apart from "./images/apart.jpg"
import Car from "./images/car_rental1.png"
import catering from "./images/catering.jpg"
import coach from "./images/coach_rental.png"
import tickets from "./images/tickets.jpg"
import guide from "./images/tour_guide.jpeg"
import tours from "./images/tours.jpg"
import { ArrowRight } from 'lucide-react'; // This is now unused but kept in imports for safety

export interface SectionServiceProps {
  className?: string;
  data?: {
    id: number;
    title: string;
    desc: string;
    img: string;
    imgDark?: string;
  }[];
}

const DEMO_DATA: SectionServiceProps["data"] = [
  {
    id: 1,
    img: Business,
    title: "BUSINESS TRAVEL",
    desc: "If your client is planning a conference, a wedding, a yoga retreat or a school tour, we can make all the arrangements for you. Our staff have the expertise and contacts for all special events and special interest tours",
  },
  {
    id: 2,
    img: Event,
    title: "EVENT MANAGEMENT",
    desc: "If your client is planning a conference, a wedding, a yoga retreat or a school tour, we can make all the arrangements for you. Our staff have the expertise and contacts for all special events and special interest tours.",
  },
  {
    id: 3,
    img: Flim,
    title: "FILM LINE PRODUCTION",
    desc: "As with all our special interest tours. We are doing FILM LINE PRODUCTION also, We have contacts all over the Europe regarding locations and permits, staff and catering. We will be delighted to help your Project.",
  },
  {
    id: 4,
    img: Transport,
    title: "TRANSPORTATIONS",
    desc: "We have partnerships and connections with private drivers and guides all over Europe. Whether you want an airport transfer, a half-day or a full day driver at your disposal, we can arrange it.",
  },
  {
    id: 5,
    img: Hotel,
    title: "HOTELS BOOKINGS",
    desc: "We manage and book all aspects of accommodation and have excellent buying power with deluxe hotels, boutique hotels, Whether you want one night or one month, have an FIT booking or a group booking, we will be delighted to handle the arrangements for you. And our rates will always be competitive.",
  },
  {
    id: 6,
    img: Apart,
    title: "APARTMENTS",
    desc: "If you are looking for a long stay for your clients, have business travellers or a family, we have an excellent range of apartments, ranging from studios to penthouses. Catered, or self catering, we will handle these arrangements for you.",
  },
  {
    id: 7,
    img: coach,
    title: "COACH RENTAL",
    desc: " Group travel can be particularly demanding. Let us take over all aspects of the group for you, including the coach rental. Whether you need a small van or a 80 seater coach, we have the contacts. And expertise.",
  },
  {
    id: 8,
    img: Car,
    title: "CAR RENTAL",
    desc: "Not only will we arrange your car hire but we will remind you about International driving licenses and chat to you about all the insurances. Long and short term rentals, budget and luxury cars - we can do it all.",
  },

  {
    id: 9,
    img: guide,
    title: "TOUR GUIDE",
    desc: "Very often a trip, business or leisure, is dependant on the tour guide. We have an excellent range of tour guides all over the Europe and will always give you the best. Of course we will talk to you about language too.",
  },

  {
    id: 10,
    img: tickets,
    title: "TICKETS",
    desc: "Sightseeing is often easier if tickets are booked in advance, particularly in high season. We have access to sightseeing tickets all over the Europe and will happily arrange your cable car, museum entry, ferry ticket, train ticket or theatre ticket too. One person? No problem. A group? No problem either..",
  },
  {
    id: 11,
    img: catering,
    title: "CATERING SERVICES",
    desc: "Our clients very often have special dietary requirements. Whether you are on a low fat diet, gluten-free, vegetarian, vegan, Halaal or kosher, we can assist. If you need catering for a large event, please talk to us too.",
  },


  {
    id: 12,
    img: tours,
    title: "TOURS & SIGHTSEEING",
    desc: "We book scheduled tours and private tours and will always give you the options. If your client is on a tight budget, we recommend schedule. If they have time, private. We will prebook your tours and sightseeing arrangements. Walking tours are our speciality too.",
  },
];

const SectionService: FC<SectionServiceProps> = ({
  className = "",
}) => {
  return (
    <div
      className={`nc-SectionService bg-white ${className}`} // 1. CHANGE: Component background to white
      data-nc-id="SectionService"
    >
      <div className="px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <div className="max-w-7xl mx-auto">
          <div className="mb-4">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-amber-500/10 rounded-full border border-amber-500/20">
              <span className="w-2 h-2 bg-amber-500 rounded-full"></span>
              <span className="text-xs sm:text-sm font-medium text-amber-600">
                Our Offerings
              </span>
            </span>
          </div>
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight tracking-tight text-balance">
            Our Services
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl leading-relaxed">
            Comprehensive travel solutions tailored to your needs. From accommodations to transportation, we handle every detail of your European journey.
          </p>
        </div>
      </div>

      <div className="px-4 sm:px-6 lg:px-8 pb-16 sm:pb-24">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6">
            {DEMO_DATA.map((item: any) => {
              return (
                <div
                  key={item.id}
                  // 3. CHANGE: Card styling for white background
                  className="group relative overflow-hidden rounded-xl border border-gray-200 bg-white shadow-lg transition-all duration-300 hover:border-amber-500/50 hover:shadow-xl hover:shadow-amber-100"
                >
                  {/* Image Container */}
                  <div className="relative h-56 overflow-hidden bg-gray-50">
                    <img
                      src={item.img || "/placeholder.svg"}
                      alt={item.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    {/* Overlay gradient (adjusted for light mode visibility) */}
                    <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent opacity-30 group-hover:opacity-20 transition-opacity duration-300"></div>
                  </div>

                  {/* Content Container */}
                  <div className="relative p-6 flex flex-col h-64">
                    {/* Title */}
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 leading-tight group-hover:text-amber-600 transition-colors duration-300">
                      {item.title}
                    </h3>

                    {/* Description */}
                    <p className="text-sm text-gray-600 mb-6 flex-grow line-clamp-4 leading-relaxed">
                      {item.desc}
                    </p>

                    {/* CTA Arrow - REMOVED 'LEARN MORE' SECTION */}
                    {/* The remaining space is now available above */}

                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionService;